
import { FaCartPlus, FaLongArrowAltRight } from 'react-icons/fa';
import React, { useState, useEffect, useRef } from 'react';
import './Dashboard.css';
import { RiCustomerService2Fill } from 'react-icons/ri';
import { MdAccountBalanceWallet } from 'react-icons/md';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { TableVirtuoso } from 'react-virtuoso';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../Config';
import { GoArrowRight } from 'react-icons/go';
import { CiWallet } from 'react-icons/ci';
import ReviewForm from './Reviewrate';
import CategoryCardView from './Categorycard';
import {
    FaRegClipboard,
    FaFileAlt,
    FaChartLine,
    FaVideo,
    FaPhoneAlt,
    FaMicrophone,
    FaStickyNote,
    FaQuestionCircle,
    FaUser,
    FaKey,
    FaShoppingBag,
    FaRegStar,
    FaWallet,
    FaHandsHelping
} from "react-icons/fa";
import { useVerification } from '../../context/VerificationContext';
import EmailMobileVerification from '../../Header/Verifycomponent';
import AlertSection from './AlertSection';
import Alertinterview from './Interviewalert';
import WelcomeBonusPopup from './WelcomeBonusPopup';



const columns = [
    {
        width: 200,
        label: 'Date & Time',
        dataKey: 'datetime',
    },
    {
        width: 120,
        label: 'Order ID',
        dataKey: 'orderid',
        numeric: true,
    },
    {
        width: 120,
        label: 'Service Name',
        dataKey: 'email',
        numeric: true,
    },
    {
        width: 150,
        label: 'Amount Paid',
        dataKey: 'mobile',
        numeric: true,
    },
    {
        width: 120,
        label: 'Payment Status',
        dataKey: 'location',
        numeric: true,
    },
    {
        width: 120,
        label: 'Action',
        dataKey: 'series',
        numeric: true,
    },

];




const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
function fixedHeaderContent() {
    return (
        <TableRow>
            {columns.map((column) => (
                <TableCell
                    key={column.dataKey}
                    variant="head"
                    align={column.numeric || false ? 'right' : 'left'}
                    style={{ width: column.width }}
                    sx={{
                        backgroundColor: 'background.paper',
                        fontWeight: "800"
                    }}
                >
                    {column.label}
                </TableCell>
            ))}
        </TableRow>
    );
}

function rowContent(_index, row) {
    return (
        <React.Fragment>
            {columns.map((column) => (
                <TableCell
                    key={column.dataKey}
                    align={column.numeric || false ? 'right' : 'left'}
                >
                    {row[column.dataKey]}
                </TableCell>
            ))}
        </React.Fragment>
    );
}



function DashBoard() {
    useEffect(() => {
          // Sirf is page pe load hoga
          const script = document.createElement('script');
          script.src = 'https://sdk.cashfree.com/js/v3/cashfree.js';
          script.async = true;
          document.body.appendChild(script);
      
          // Cleanup jab page change ho
          return () => {
            document.body.removeChild(script);
          };
        }, []);
    const { openVerification } = useVerification();
    const [activeButton, setActiveButton] = useState('Test Series');

    const handleButtonClick = (buttonName) => {
        setActiveButton(buttonName);
    };
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [open1, setOpen1] = React.useState(false);
    const handleClickOpen1 = () => {
        setOpen1(true);
    };

    const handleClose1 = () => {
        setOpen1(false);
    };
    const userdatatoken = localStorage.getItem('userDatatoken');
    const token = localStorage.getItem('token_type');
    const tokenid = 'Bearer' + userdatatoken
    const tokendata = tokenid.replace(/"/g, ' ');
    const [data, setData] = useState([])
    const [paymentdata, setPaymentData] = useState('')
    const [orderid, setOrderid] = useState('')
    const [paymentmethod, setPaymentmethod] = useState('cashfree')
    const [formerror, setFormerror] = useState([])
    const [formerror1, setFormerror1] = useState([])
    const [formerror2, setFormerror2] = useState([])
    const [userProfile, setUserProfile] = useState(null);

    useEffect(() => {


        fetchProfileData()
    }, []);
    const [userdata1, setUserdata1] = useState('')
    const navigate = useNavigate();

    const fetchProfileData = async () => {
        axios.get(BASE_URL + 'profiles', {
            headers: {
                Accept: "application/json",
                Authorization: tokendata

            }
        }).then(({ data }) => {
            setUserProfile(data?.data);
            setUserdata1(data.data)

        })
    };
    const userdata = localStorage.getItem("userData");
    const [amount, setAmount] = useState('')
    console.log(paymentmethod)
    const addmoney = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append("online_payment_mode", paymentmethod);
        formData.append("amount", amount);
         formData.append("redirect", "wallet");

        const apiUrl = paymentmethod == "cashfree"
            ? BASE_URL + "proceed-add-to-wallet"
            : BASE_URL + "proceed-add-to-wallet";

        try {
            const response = await axios.post(apiUrl, formData, {
                headers: {
                    "content-type": "multipart/form-data",
                    Accept: "application/json",
                    Authorization: tokendata,
                },
            });

            if (response.data.success === true) {
                setPaymentData(response.data);
                setOrderid(response.data.order_id);
                console.log(response.data.order_id);
            } else {
                // handle error cases here
            }
        } catch (error) {
            if (error.response) {
                console.log(error.response.data);
            } else if (error.request) {
                console.log(error.request);
            } else {
                console.log("Error", error.message);
            }
            console.log(error.config);
        }
    };


    useEffect(() => {
        if (paymentdata && paymentdata.data && paymentdata.data.payment_session_id) {
            handlePaymentcashfree();
        }
    }, [paymentdata]);

    const handlePaymentcashfree = () => {
        const cashfree = window.Cashfree({
            mode: "sandbox" //or production,
        });
        cashfree.checkout({
            paymentSessionId: paymentdata.data.payment_session_id
        });
    };

    const payment = () => {
        window.location.href = paymentdata.payment_url
    };
    useEffect(() => {
        const loadRazorpayScript = () => {
            const script = document.createElement('script');
            script.src = 'https://checkout.razorpay.com/v1/checkout.js';
            script.async = true;
            document.body.appendChild(script);
            script.onload = () => {
                initializeRazorpay();
            };
        };

        const initializeRazorpay = () => {

            if (window.Razorpay) {
                const options = {
                    "key": paymentdata.key, // Ensure that data.key exists
                    "amount": paymentdata.amount,
                    "currency": paymentdata.currency,
                    "name": paymentdata.name,
                    "description": "Test Transaction",
                    "image": "https://example.com/your_logo",
                    "order_id": paymentdata.order_id,
                    "callback_url": "https://eneqd3r9zrjok.x.pipedream.net/",
                    "prefill": {
                        "name": "Janmejay Kumar",
                        "email": "janmejay.kumar@example.com",
                        "contact": "9000090000"
                    },
                    "notes": {
                        "address": "Razorpay Corporate Office"
                    },
                    "theme": {
                        "color": "#3399cc"
                    }
                };
                const rzp1 = new window.Razorpay(options);
                document.getElementById('rzp-button1').onclick = function (e) {
                    rzp1.open();
                    e.preventDefault();
                }
            } else {
                console.error("Razorpay script not loaded.");
            }
        };

        loadRazorpayScript();
    }, [paymentdata]);

    const creditamount = data
        .filter((e) => e.transaction_type === "credit")
        .reduce((total, e) => total + parseFloat(e.amount), 0);

    const debitamount = data
        .filter((e) => e.transaction_type === "debit")
        .reduce((total, e) => total + parseFloat(e.amount), 0);

    const sampleRows = [
        { datetime: '2025-01-10 14:30', orderid: 'OID993939', email: 'john@gmail.com', mobile: '+91-898989899', location: 'Delhi', series: 'UPSSC', amount: 999, status: 'Success' },
        // ... और rows add करो
    ];


    const filteredRows = sampleRows.filter(row => {
        if (activeButton === 'Test Series') return row.series.includes('SSC') || row.series.includes('Test');
        if (activeButton === 'Teachers on Call') return row.series.includes('Teacher') || row.series.includes('Call');
        if (activeButton === 'Live Classes') return row.series.includes('Live');
        if (activeButton === 'Interviews') return row.series.includes('Interview');
        return true;
    });

    const [openemail, setOpenemail] = React.useState(false);
    const handleClickOpenemail = () => {
        const isEmailVerified = userProfile.email_verified === "yes";
        const isMobileVerified = userProfile.mobile_verified === "yes";

        if (!isEmailVerified && !isMobileVerified) {
            openVerification('mobile');
            return;
        }

        if (!isEmailVerified) {
            openVerification('email');
            return;
        }

        if (!isMobileVerified) {
            openVerification('mobile');
            return;
        }
    };

    const handleCloseemail = () => {
        setOpenemail(false);
    };
    const [otpstatus, setOtpstatus] = useState(false)
    const [otpchange, setOtpchange] = useState('')
    const [otpemail, setOtpemail] = useState('')

    const [otpsendemail, setOtpsendemail] = useState('')
    const [interviewdata, setInterviewdata] = useState([])
    const [welcomebonus, setWelcomeBonus] = useState(null);
    const [showBonusPopup, setShowBonusPopup] = useState(false);

    const sendotpemail = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append("email", otpemail);



        try {
            const response = await axios.post(BASE_URL + "send-otp-change-email", formData, {
                headers: {
                    "content-type": "multipart/form-data",
                    Accept: "application/json",
                    Authorization: tokendata,
                },
            });

            if (response.data) {
                setOtpstatus(true)
                fetchProfileData();
            }

        } catch (error) {
            setFormerror1(error.response.data.errors)
            console.log("Error updating profile:", error);
        }
    };
    const verifyemail = async (e) => {
        e.preventDefault();

        const formData = new FormData();
        formData.append("email", otpemail);
        formData.append("otp", otpsendemail);


        try {
            const response = await axios.post(BASE_URL + "update-email", formData, {
                headers: {
                    "content-type": "multipart/form-data",
                    Accept: "application/json",
                    Authorization: tokendata,
                },
            });

            if (response.data) {

                fetchProfileData(); // Refresh the profile data after update
                setOpenemail(false)
            }

        } catch (error) {
            console.log("Error updating profile:", error);
        }
    };




    useEffect(() => {

        fetchPackageData();
        fetchinterviewdata();


    }, []);

    const effectRan = useRef(false);

    useEffect(() => {
        if (!effectRan.current) {
            fetchbonusdata();
            effectRan.current = true;
        }
    }, []);
    const fetchPackageData = async () => {
        axios.get(BASE_URL + 'liveclassorders', {
            headers: {
                Accept: "application/json",
                Authorization: tokendata

            }
        }).then(({ data }) => {
            if (data.data && data.data) {
                setData(data.data);

            } else {
                setData([]);

            }


        })
    };
    const fetchinterviewdata = async () => {
        axios.get(BASE_URL + 'intervieworders', {
            headers: {
                Accept: "application/json",
                Authorization: tokendata

            }
        }).then(({ data }) => {
            if (data.data && data.data) {
                setInterviewdata(data.data);

            } else {
                setInterviewdata([]);

            }


        })
    };
    const fetchbonusdata = async () => {
        axios.get(BASE_URL + 'check-welcome-bonus', {
            headers: {
                Accept: "application/json",
                Authorization: tokendata

            }
        }).then(({ data }) => {
            console.log(data)
            setWelcomeBonus(data);
            


        })
    };

    const copyReferralLink = () => {
        const fullLink = `https://theexamtime.com${userdata1.referral_path}`;
        navigator.clipboard.writeText(fullLink);
        alert("Referral Link Copied!");
    };




    useEffect(() => {
        if (welcomebonus?.show_popup) {
            setShowBonusPopup(true);
        }
    }, [welcomebonus]);

    return (
        <div className="dashboard-main-card ">
            <WelcomeBonusPopup
                show={showBonusPopup}
                amount={welcomebonus?.amount}
                message={welcomebonus?.message}
                onClose={() => setShowBonusPopup(false)}
            />

            <EmailMobileVerification />
            {userdata1.email_verified !== "yes" && (
                <div className='alert-message mt-5'>
                    <p className='m-0'>
                        You have not verified your Email Id, kindly click on Verify Now to verify and get full access to your Dashboard.
                        <span onClick={handleClickOpenemail}>Verify Now</span>
                    </p>
                </div>
            )}
            {userdata1.mobile_verified !== "yes" && (
                <div className='alert-message mt-2'>
                    <p className='m-0'>
                        You have not verified your mobile number, kindly click on Verify Now to verify and get full access to your Dashboard.
                        <span onClick={handleClickOpenemail}>Verify Now</span>
                    </p>
                </div>
            )}
            {userdata1.referral_path && userdata1.referral_path.trim() !== "" && (
                <div
                    className="referral-alert-box mt-3"
                    style={{
                        background: "#f0f8ff",
                        padding: "12px 16px",
                        borderRadius: "8px",
                        border: "1px solid #cce7ff",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap", marginBottom: "20px"
                    }}
                >
                    <div style={{ fontSize: "14px", fontWeight: "500", color: "#004a8f" }}>
                        🎉 You have a referral invite! Earn rewards by sharing your link.
                    </div>

                    <button
                        onClick={copyReferralLink}
                        style={{
                            background: "#007bff",
                            border: "none",
                            color: "white",
                            padding: "6px 16px",
                            borderRadius: "6px",
                            cursor: "pointer",
                            fontSize: "14px",
                            fontWeight: "600",
                            
                        }}
                    >
                        Share Referral
                    </button>
                </div>
            )}



            <AlertSection data={data} />
            <Alertinterview data={interviewdata} />


            <div className="newupdateindashboard-container">

                {/* ---------- 1st Row ---------- */}
                <div className="newupdateindashboard-row">

                    <div className="newupdateindashboard-card" style={{ "--bg": "#E8F0FE" }} onClick={() => navigate("/package-test-series")}>
                        <FaRegClipboard className="newupdateindashboard-icon" />
                        <span>Test<br></br> Series</span>
                    </div>

                    <div className="newupdateindashboard-card" style={{ "--bg": "#FFF3E0" }} onClick={() => navigate("/start-test")}>
                        <FaFileAlt className="newupdateindashboard-icon" />
                        <span>Test <br></br>Papers</span>
                    </div>

                    <div className="newupdateindashboard-card" style={{ "--bg": "#E8F5E9" }} onClick={() => navigate("/test-results")}>
                        <FaChartLine className="newupdateindashboard-icon" />
                        <span>Test<br></br> Results</span>
                    </div>

                    <div className="newupdateindashboard-card" style={{ "--bg": "#F3E5F5" }} onClick={() => navigate("/live-classes-package-details")}>
                        <FaVideo className="newupdateindashboard-icon" />
                        <span>Live <br></br>Classes</span>
                    </div>

                </div>

                {/* ---------- 2nd Row ---------- */}
                <div className="newupdateindashboard-row">

                    <div className="newupdateindashboard-card" style={{ "--bg": "#E0F7FA" }} onClick={() => navigate("/teacheroncall/package-details")}>
                        <FaPhoneAlt className="newupdateindashboard-icon" />
                        <span>Teacher On Call</span>
                    </div>

                    <div className="newupdateindashboard-card" style={{ "--bg": "#FFFDE7" }} onClick={() => navigate("/interview-package-details")}>
                        <FaMicrophone className="newupdateindashboard-icon" />
                        <span>Interviews</span>
                    </div>

                    <div className="newupdateindashboard-card" style={{ "--bg": "#FBE9E7" }} onClick={() => navigate("/notes")}>
                        <FaStickyNote className="newupdateindashboard-icon" />
                        <span>My Notes</span>
                    </div>

                    <div className="newupdateindashboard-card" style={{ "--bg": "#F1F8E9" }} onClick={() => navigate("/quiz")}>
                        <FaQuestionCircle className="newupdateindashboard-icon" />
                        <span>Quiz</span>
                    </div>

                </div>

                {/* ---------- 3rd Row (Full Width Wallet) ---------- */}
                <div className="newupdateindashboard-row-full">
                    <div className="newupdateindashboard-wallet-card">
                        <FaWallet className="newupdateindashboard-wallet-icon" />

                        {/* <h3 className="newupdateindashboard-wallet-title">My Wallet</h3> */}

                        <h2 className="newupdateindashboard-wallet-balance">
                            ₹{Number(userdata1.wallet_amount).toLocaleString("en-IN")}/-
                        </h2>

                        <button
                            className="newupdateindashboard-wallet-button"
                            onClick={handleClickOpen1}
                        >
                            + Add Fund to Wallet
                        </button>
                    </div>
                </div>

                {/* ---------- 4th Row ---------- */}
                <div className="newupdateindashboard-row">
                    <div className="newupdateindashboard-card" style={{ "--bg": "#E3F2FD" }} onClick={() => navigate("/student-profile")}>
                        <FaUser className="newupdateindashboard-icon" />
                        <span>My Profile</span>
                    </div>

                    <div className="newupdateindashboard-card" style={{ "--bg": "#FCE4EC" }} onClick={() => navigate("/student-profile")}>
                        <FaKey className="newupdateindashboard-icon" />
                        <span>Account Password</span>
                    </div>

                    <div className="newupdateindashboard-card" style={{ "--bg": "#E8EAF6" }} onClick={() => navigate("/orders")}>
                        <FaShoppingBag className="newupdateindashboard-icon" />
                        <span>My Orders</span>
                    </div>

                    <div className="newupdateindashboard-card" style={{ "--bg": "#FFF8E1" }} onClick={() => navigate("/subscription")}>
                        <FaRegStar className="newupdateindashboard-icon" />
                        <span>Subscriptions</span>
                    </div>
                </div>

                {/* ---------- 5th Row (2 Cards) ---------- */}
                <div className="newupdateindashboard-row">
                    <div className="newupdateindashboard-card" style={{ "--bg": "#E0F2F1" }} onClick={() => navigate("/feedback")}>
                        <FaRegStar className="newupdateindashboard-icon" />
                        <span>Feedback & Reviews</span>
                    </div>

                    <div className="newupdateindashboard-card" style={{ "--bg": "#EDE7F6" }} onClick={() => navigate("/help-support")}>
                        <FaHandsHelping className="newupdateindashboard-icon" />
                        <span>Help & Support</span>
                    </div>
                </div>

            </div>

            <div className="tab-card mt-4 new-dashboard-cards dashboard-newdesktop">


                <div className="tab-details-card pro-card" style={{ background: "#f9f9f9" }}>
                    <h4>My Account</h4>
                    <p className="sub-text">
                        Manage your profile details, change your password, update settings from here
                    </p>
                    <div className="pro-card-footer" onClick={() => navigate("/student-profile")}>
                        <span className="footer-text">Click Here</span>
                        <GoArrowRight />
                    </div>
                </div>


                <div className="tab-details-card pro-card" style={{ background: "#14d2d61c" }}>
                    <h4>My Orders</h4>
                    <p className="sub-text">
                        Manage all your orders & invoices easily from here
                    </p>
                    <div className="pro-card-footer" onClick={() => navigate("/orders")}>
                        <span className="footer-text">Click Here</span>
                        <GoArrowRight />
                    </div>
                </div>


                <div className="tab-details-card pro-card" style={{ background: "#f030611f" }}>
                    <h4>Feedback & Reviews</h4>
                    <p className="sub-text">
                        Manage your shared feedback & submitted reviews from here
                    </p>
                    <div className="pro-card-footer" onClick={() => navigate("/feedback")}>
                        <span className="footer-text">Click Here</span>
                        <GoArrowRight />
                    </div>
                </div>


                <div className="tab-details-card pro-card" style={{ background: "#89f89433" }}>
                    <h4>My Wallet</h4>
                    <h3
                        style={{
                            color: "#0BA82D",
                            fontWeight: "800",
                            fontSize: "32px",
                            marginBottom: "8px"
                        }}
                    >
                        ₹{Number(userdata1.wallet_amount).toLocaleString("en-IN")}/-
                    </h3>

                    <div className="wallet-extra">


                        <button className="wallet-btn" onClick={handleClickOpen1}>
                            + Add Fund to Wallet
                        </button>
                    </div>
                </div>

            </div>

            <Dialog

                open={openemail}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleCloseemail}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle style={{ borderBottom: "1px solid gray", marginBottom: "10px", fontSize: "20px", fontWeight: "700", width: "500px" }}>{"E-mail Update"}</DialogTitle>
                <DialogContent>
                    {/* <p className='mb-5' style={{ marginBottom: "10px", fontSize: "13px", fontWeight: "700" }}>{"We have sent OTP to your registered Mobile Number, Please enter to Verify"}</p> */}
                    <DialogContentText id="alert-dialog-slide-description" >
                        <form>

                            <div class="form-group row mt-3">
                                <label for="inputPassword" class="col-sm-4 col-form-label">E-mail</label>
                                <div class="col-sm-8">
                                    <input type="text" class="form-control" id="inputPassword" placeholder="E-mail" onChange={(e) => setOtpemail(e.target.value)} />
                                    {formerror1.email && <p className="error">{formerror1.email}</p>}
                                </div>
                            </div>
                            {otpstatus == true ? <div class="form-group row mt-3">
                                <label for="inputPassword" class="col-sm-4 col-form-label">OTP</label>
                                <div class="col-sm-8">
                                    <input type="text" class="form-control" id="inputPassword" placeholder="OTP" onChange={(e) => setOtpsendemail(e.target.value)} />
                                </div>
                            </div> : null}

                        </form>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    {otpstatus == true ? <Button onClick={verifyemail}>Update Now</Button> : <Button onClick={sendotpemail}>Send OTP</Button>}

                </DialogActions>
            </Dialog>
            <Dialog
                open={open1}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose1}
                aria-describedby="alert-dialog-slide-description"
                PaperProps={{
                    style: {
                        width: "520px",
                        borderRadius: "12px",
                        padding: "10px",
                    },
                }}
            >
                {/* ---------- Header With Close Button ---------- */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "10px 20px",
                        borderBottom: "1px solid #ddd",
                    }}
                >
                    <DialogTitle
                        style={{
                            padding: 0,
                            fontSize: "20px",
                            fontWeight: "700",
                        }}
                    >
                        Recharge Wallet
                    </DialogTitle>

                    <span
                        onClick={handleClose1}
                        style={{
                            cursor: "pointer",
                            fontSize: "22px",
                            fontWeight: "600",
                        }}
                    >
                        ✕
                    </span>
                </div>

                {/* ---------------- Main Content ---------------- */}
                <DialogContent style={{ padding: "20px" }}>
                    <DialogContentText id="alert-dialog-slide-description">
                        <form style={{ width: "100%" }}>

                            {/* Amount Input */}
                            <div className="form-group mb-4" style={{ display: "flex", alignItems: "center" }}>
                                <div
                                    style={{
                                        fontSize: "45px",
                                        marginRight: "15px",
                                        opacity: "0.8",
                                    }}
                                >
                                    <CiWallet />
                                </div>

                                <input
                                    type="number"
                                    className="form-control"
                                    placeholder="Enter Amount"
                                    onChange={(e) => setAmount(e.target.value)}
                                    style={{
                                        height: "45px",
                                        borderRadius: "8px",
                                        fontSize: "15px",
                                    }}
                                />
                            </div>

                            {/* Payment Method */}
                            <label style={{ fontWeight: "600", fontSize: "14px" }}>Select Payment Method</label>
                            <select
                                className="form-control mt-2"
                                value={paymentmethod}
                                onChange={(e) => setPaymentmethod(e.target.value)}
                                style={{
                                    height: "45px",
                                    borderRadius: "8px",
                                    fontSize: "15px",
                                }}
                            >
                                <option value="">Choose Payment Method</option>
                                <option value="cashfree">Cashfree</option>
                                <option value="razorpay">Razorpay</option>
                            </select>

                        </form>
                    </DialogContentText>
                </DialogContent>

                {/* ---------------- Footer Button ---------------- */}
                <DialogActions style={{ padding: "15px 20px" }}>
                    {paymentmethod === "cashfree" ? (
                        <Button
                            onClick={addmoney}
                            style={{
                                backgroundColor: "#0A7CFF",
                                color: "#fff",
                                textTransform: "none",
                                padding: "8px 16px",
                                borderRadius: "8px",
                                fontSize: "14px",
                            }}
                        >
                            Add Amount
                        </Button>
                    ) : (
                        <Button
                            id="rzp-button1"
                            style={{
                                backgroundColor: "#0A7CFF",
                                color: "#fff",
                                textTransform: "none",
                                padding: "8px 16px",
                                borderRadius: "8px",
                                fontSize: "14px",
                            }}
                        >
                            Add Amount
                        </Button>
                    )}
                </DialogActions>
            </Dialog>


            <div className='category-table-list-card mt-4 '>

                <div className="category-table-card">
                    <CategoryCardView
                        rows={filteredRows}
                        activeButton={activeButton}
                        handleButtonClick={handleButtonClick}
                    />
                </div>
                <div className='review-table-card'>
                    <ReviewForm />
                </div>

            </div>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle style={{ borderBottom: "1px solid gray", marginBottom: "10px", fontSize: "20px", fontWeight: "700" }}>{"Verify OTP"}</DialogTitle>
                <DialogContent>
                    <p className='mb-5' style={{ marginBottom: "10px", fontSize: "13px", fontWeight: "700" }}>{"We have sent OTP to your registered Mobile Number, Please enter to Verify"}</p>
                    <DialogContentText id="alert-dialog-slide-description" >
                        <form>

                            <div class="form-group row mt-3">
                                <label for="inputPassword" class="col-sm-4 col-form-label">Enter OTP</label>
                                <div class="col-sm-8">
                                    <input type="password" class="form-control" id="inputPassword" placeholder="Enter OTP here" />
                                </div>
                            </div>
                        </form>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    {/* <Button onClick={handleClose}>Disagree</Button> */}
                    <Button onClick={handleClose}>Verify Now</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

export default DashBoard;
